import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Flex,
  Text,
} from "@chakra-ui/react";
import { RiEditLine } from "react-icons/ri";
import { type OfferingCategory } from "src/generated/hooks/form-service/requests";

export function OfferingCategoryView({
  category,
  onEdit,
}: {
  category: OfferingCategory;
  onEdit: () => void;
}) {
  return (
    <Accordion allowToggle defaultIndex={[0]}>
      <AccordionItem border="none">
        {({ isExpanded }) => (
          <>
            <Flex
              gap={2}
              p={4}
              align="center"
              bg="white"
              borderTopRadius="xl"
              borderBottomRadius={
                !isExpanded || category.options.length === 0 ? "xl" : undefined
              }
            >
              <AccordionButton
                aria-label={
                  isExpanded
                    ? "Collapse offering category"
                    : "Expand offering category"
                }
                width="32px"
                height="32px"
                p={0}
                flexShrink={0}
                justifyContent="center"
                borderRadius="md"
              >
                <AccordionIcon />
              </AccordionButton>
              <Box flex="1" minW={0}>
                <Text fontSize="xl" fontWeight="medium" color="blackAlpha.800">
                  {category.label}
                </Text>
                <Text fontSize="sm" color="gray.500">
                  {category.key}
                </Text>
              </Box>
              <Button
                variant="outline"
                colorScheme="gray"
                size="sm"
                leftIcon={<RiEditLine />}
                onClick={onEdit}
              >
                Edit offering category
              </Button>
            </Flex>
            <AccordionPanel p={0}>
              {category.options.map((option, index) => (
                <Flex
                  key={option.id}
                  pl={14}
                  pr={4}
                  py={4}
                  gap={6}
                  bg="blackAlpha.50"
                  borderTopWidth="1px"
                  borderColor="gray.200"
                  borderBottomRadius={
                    index === category.options.length - 1 ? "xl" : undefined
                  }
                >
                  <Box flex="1" minW={0}>
                    <Text fontSize="sm" fontWeight="medium" color="gray.600">
                      Offering option name
                    </Text>
                    <Text fontSize="md" color="blackAlpha.800">
                      {option.label}
                    </Text>
                  </Box>
                  <Box flex="1" minW={0}>
                    <Text fontSize="sm" fontWeight="medium" color="gray.600">
                      Offering option key
                    </Text>
                    <Text fontSize="md" color="blackAlpha.800">
                      {option.key}
                    </Text>
                  </Box>
                </Flex>
              ))}
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  );
}
